import moment from 'moment';

import { ACTIONS } from '@~/actions/enable-group-chat';

const initialState = {
  eventType: null,
  eventTime: '',
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.RECORD_ENABLE_GROUP_CHAT: {
      const { eventType } = payload;

      return {
        eventType,
        eventTime: String(Number(moment())),
      };
    }
    default:
      return state;
  }
}
